module.exports = __webpack_public_path__ + "img/outdoor_seating.a67b17d6.jpg";